// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- HS Code
import { UserNotificationBaseService } from './user-notification-base.service';
import { NotificationModel, NotificationTypes } from '../../../models';
import moment from 'moment';
import { ReportsBaseService } from '../reporting/reports-base.service';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class UserNotificationMockService extends UserNotificationBaseService {
  constructor(reportsService: ReportsBaseService) {
    super(reportsService);
  }

  connect(): void {
    const notifications: NotificationModel[] = [
      {
        id: '1',
        type: NotificationTypes.unknown,
        highlightBody: 'Annette Fisher',
        body: 'has finished an others survey',
        title: 'Survey Complete',
        dateOfNotification: moment().toDate(),
        identifier: 'annette-fisher',
        image: '/assets/images/profile-image.png',
        isRead: false,
      },
      {
        id: '2',
        type: NotificationTypes.reportDownloadReady,
        highlightBody: 'John Doe',
        body: 'your report is ready for download',
        title: 'Report Ready',
        dateOfNotification: moment().subtract(2, 'h').toDate(),
        identifier: 'john-doe',
        image: '/assets/images/profile-image.png',
        isRead: false,
      },
      {
        id: '3',
        type: NotificationTypes.unknown,
        highlightBody: 'John Doe',
        body: 'has finished an others survey',
        title: '',
        dateOfNotification: moment().subtract(5, 'd').toDate(),
        identifier: 'john-doe',
        image: '/assets/images/profile-image.png',
        isRead: true,
      }
    ];

    notifications.forEach((notification) => {
      this._processNotification(notification);
    });
  }

  signOut(): void {
  }

  view(notification: NotificationModel): void {
    const notifications = this._notifications$.value;
    notifications.forEach((notificationItem, index: number) => {
      if (notificationItem.id === notification.id) {
        notificationItem.isRead = true;
      }
    });

    this._notifications$.next(notifications);
  }
  remove(notification: NotificationModel): void {
    const notifications = this._notifications$.value;
    const notificationIndex = notifications.findIndex(x => x.id === notification.id);
    if (typeof notificationIndex !== 'undefined') {
      notifications.splice(notificationIndex, 1);
    }

    this._notifications$.next(notifications);
  }
}
